import React from 'react';
import Layout from './index/_homeLayout';

import jumbotron from 'locale/home/en/jumbotron.yml';
import cards from 'locale/home/en/cards.yml';
import facts from 'locale/home/en/facts.yml';


export default (props) => {
  return (
   <Layout cardsData={cards} factsData={facts} jumbotronData={jumbotron} {...props}/>
  )
}

export const query = graphql`
  query indexImagesEn {
    jumbotronImg: file(absolutePath: { regex: "/frontCover/" }) {
      childImageSharp {
        sizes(maxWidth: 1200, quality: 100) {
        ...GatsbyImageSharpSizes_tracedSVG
        }
      }
    }
    cardEducatorImg: file(absolutePath: { regex: "/homeEducator/" }) {
      childImageSharp {
        sizes(maxHeight: 500, quality: 100) {
        ...GatsbyImageSharpSizes_tracedSVG
        }
      }
    }
    cardLearnImg: file(absolutePath: { regex: "/homeLearn/" }) {
      childImageSharp {
        sizes(maxHeight: 500, quality: 100) {
        ...GatsbyImageSharpSizes_tracedSVG
        }
      }
    }
    cardGetInvolvedImg: file(absolutePath: { regex: "/homeGetInvolved/" }) {
      childImageSharp {
        sizes(maxHeight: 500, quality: 100) {
        ...GatsbyImageSharpSizes_tracedSVG
        }
      }
    }
  }
`


// WEBPACK FOOTER //
// ./src/pages/index.en.js